import {
  USER_LOGIN_REQ,
  USER_LOGIN_SUCCESS,
  USER_LOGIN_FAILED,
  USER_LOGIN_RESET,
  USER_LOGOUT_REQ,
} from "../Constants/userLoginConstant";
import { REMOVE_LOCAL } from "../Models/LocalData";

export const LoginReducer = (state = {}, { type, payload }) => {
  switch (type) {
    case USER_LOGIN_REQ: {
      return { Login_Loading: true };
    }

    case USER_LOGIN_SUCCESS: {
      return {
        Login_Loading: false,
        accessToken: payload.accesstoken,
        userDet: payload.Result,
      };
    }
    case USER_LOGIN_FAILED: {
      return { Login_Loading: false, accessToken: payload };
    }
    case USER_LOGIN_RESET: {
      return { Login_Loading: false, accessToken: false };
    }

    case USER_LOGOUT_REQ: {
      REMOVE_LOCAL("login_data");
      return { Login_Loading: false, Login_data: null, Login_error: false };
    }

    default:
      return state;
  }
};
